import { Link } from 'react-router-dom';

import { Logo } from '../components/Logo';
import { useAuth } from '../contexts/auth-context';

/** Landing simples: apresenta a plataforma e direciona para login/cadastro. */
export function HomePage() {
  const { user } = useAuth();

  return (
    <main className="landing">
      <div className="landing__logo">
        <Logo size={132} />
      </div>
      <h1 className="landing__title">Send Message</h1>
      <p className="landing__text">
        Receba mensagens dos seus espectadores em tempo real durante as lives e acompanhe seus
        recebimentos em uma dashboard simples.
      </p>

      <div className="landing__actions">
        {user ? (
          <Link className="button button--primary" to="/dashboard">
            Ir para a dashboard
          </Link>
        ) : (
          <>
            <Link className="button button--primary" to="/cadastro">
              Criar minha conta
            </Link>
            <Link className="button button--ghost" to="/login">
              Já tenho conta
            </Link>
          </>
        )}
      </div>

      <p className="landing__hint">
        É espectador? Acesse a página do criador pelo link que ele divulgou (ex.:{' '}
        <code>/nome-do-criador</code>).
      </p>
    </main>
  );
}
